import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface PullRequestCommentsData {
  comments: any[]
}

@Component({
  selector: 'app-pull-request-comments',
  templateUrl: './pull-request-comments.component.html',
  styleUrls: ['./pull-request-comments.component.css']
})
export class PullRequestCommentsComponent {

  constructor(
    public dialogRef: MatDialogRef<PullRequestCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PullRequestCommentsData) {}

  onClose(): void {
    this.dialogRef.close();
  }

}